import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = ["innerHTML"]

import { ref } from 'vue'
import Modal from './Modal.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    references: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  references: string[]
}



const referencesModal = ref<InstanceType<typeof Modal> | null>(null)

async function show() {
  referencesModal.value?.show()
}

expose({
  show,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "referencesModal",
    ref: referencesModal,
    class: "modal-references",
    title: _ctx.$t('referencesModal.title'),
    "validate-btn-text": _ctx.$t('referencesModal.button')
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.references, (reference, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(index + 1) + ". ", 1),
            _createElementVNode("span", { innerHTML: reference }, null, 8, _hoisted_2)
          ])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title", "validate-btn-text"]))
}
}

})